import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-apisalinty-vertical',
  standalone: false,
  templateUrl: './apisalinty-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class ApisalintyVerticalComponent   {
@Input() apisalintyTest:any;

}
